import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// ------------------------------------------------------------------
// Adjunta automáticamente el token a las peticiones hacia la API.
// El backend ahora exige login en todas las rutas /api/* (excepto
// /api/login); varias pantallas usaban fetch() sin token y, sin esto,
// dejarían de funcionar.
// ------------------------------------------------------------------
const API_BASE = (process.env.REACT_APP_API_URL || 'https://api.hmsaa.com.mx:5001')
  .replace(/\/api\/?$/, '')
  .replace(/\/$/, '');

const originalFetch = window.fetch.bind(window);

window.fetch = (input, init = {}) => {
  const url = typeof input === 'string' ? input : (input && input.url) || String(input);
  const esApi = url.startsWith(`${API_BASE}/api/`) && !url.includes('/api/login');
  const token = localStorage.getItem('access_token');

  if (!esApi || !token) {
    return originalFetch(input, init);
  }

  const headers = new Headers(
    init.headers || (typeof input !== 'string' && input.headers) || undefined
  );
  if (!headers.has('Authorization')) {
    headers.set('Authorization', `Bearer ${token}`);
  }

  return originalFetch(input, { ...init, headers });
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
